import React from 'react';
import { Typography, Divider, Anchor } from 'antd';
import { Helmet } from 'react-helmet-async';
import { theme } from '../../styles/theme';
import { TERMS_CONTENT } from '../../constants/termsContent';

const { Title, Paragraph, Text } = Typography;
const { Link } = Anchor;

const TermsOfServicePage = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Service - HSP | HammerSawPaint</title>
        <meta name="description" content="Terms of Service for HammerSawPaint home maintenance platform. California-compliant legal terms governing use of our service coordination platform." />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <div style={{ minHeight: '100vh', marginTop: '80px', background: theme.colors.white }}>
        {/* Hero Section */}
        <section style={{ 
          background: `linear-gradient(135deg, ${theme.colors.primary} 0%, ${theme.colors.primaryDark} 100%)`,
          padding: '60px 20px',
          color: 'white'
        }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
            <Title level={1} style={{ 
              color: 'white', 
              marginBottom: '1rem',
              fontFamily: theme.fonts.primary,
              fontSize: '2.5rem'
            }}>
              {TERMS_CONTENT.hero.title}
            </Title>
            <Text style={{ 
              color: 'white', 
              fontSize: '1.1rem',
              fontFamily: theme.fonts.primary
            }}>
              {TERMS_CONTENT.hero.subtitle}
            </Text>
            <br />
            <Text style={{ 
              color: 'white', 
              fontSize: '1rem',
              fontFamily: theme.fonts.primary,
              opacity: 0.9
            }}>
              {TERMS_CONTENT.hero.effectiveDate}
            </Text>
          </div>
        </section>

        {/* Content Section */}
        <section style={{ padding: '60px 20px' }}>
          <div style={{ maxWidth: '900px', margin: '0 auto' }}>
            
            {/* Table of Contents */}
            <div style={{ 
              background: theme.colors.lightGray,
              padding: '2rem',
              borderRadius: theme.borderRadius.lg,
              marginBottom: '3rem'
            }}>
              <Title level={4} style={{ fontFamily: theme.fonts.primary, marginBottom: '1rem' }}>
                Table of Contents
              </Title>
              <Anchor
                affix={false}
                offsetTop={100}
                style={{ fontFamily: theme.fonts.primary }}
              >
                {TERMS_CONTENT.sections.map((section, index) => (
                  <Link 
                    key={index}
                    href={`#section-${index}`}
                    title={section.title}
                  />
                ))}
              </Anchor>
            </div>

            {/* Sections */}
            {TERMS_CONTENT.sections.map((section, index) => (
              <div key={index} id={`section-${index}`} style={{ marginBottom: '3rem' }}>
                <Title level={2} style={{ 
                  fontFamily: theme.fonts.primary,
                  color: theme.colors.primary,
                  marginBottom: '1.5rem'
                }}>
                  {section.title}
                </Title>
                
                {section.content && section.content.map((paragraph, pIndex) => (
                  <Paragraph key={pIndex} style={{ 
                    fontSize: '1rem',
                    lineHeight: '1.8',
                    fontFamily: theme.fonts.primary,
                    marginBottom: '1rem',
                    whiteSpace: 'pre-line'
                  }}>
                    {paragraph}
                  </Paragraph>
                ))}
                
                {index < TERMS_CONTENT.sections.length - 1 && (
                  <Divider style={{ margin: '2rem 0' }} />
                )}
              </div>
            ))}

            {/* Footer Acknowledgment */}
            <div style={{
              background: theme.colors.lightGray,
              padding: '2rem',
              borderRadius: theme.borderRadius.lg,
              marginTop: '3rem',
              borderLeft: `4px solid ${theme.colors.primary}`
            }}>
              <Text strong style={{ 
                fontSize: '1.1rem',
                fontFamily: theme.fonts.primary,
                display: 'block',
                marginBottom: '1rem'
              }}>
                Important Notice
              </Text>
              <Paragraph style={{ 
                fontFamily: theme.fonts.primary,
                marginBottom: '1rem'
              }}>
                {TERMS_CONTENT.footer.acknowledgment}
              </Paragraph>
              <Text style={{ 
                fontSize: '0.9rem',
                fontFamily: theme.fonts.primary,
                fontStyle: 'italic',
                color: theme.colors.gray
              }}>
                {TERMS_CONTENT.footer.lastUpdated}
              </Text>
            </div>

          </div>
        </section>
      </div>
    </>
  );
};

export default TermsOfServicePage;
